import { Injectable } from "@angular/core";
import { StepWS } from "@app/core/on-boarding/data/network/step.ws";
import { StepRepo } from "@app/core/on-boarding/domain/step.repo";
import { Step } from "@app/core/on-boarding/domain/model/step";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class StepDataRepo implements StepRepo {
  constructor(private ws: StepWS) {}

  getSteps(): Observable<Step[]> {
    return this.ws.execute();
  }
}
